import { render } from "./TypeWriter.vue?vue&type=template&id=80dc6f64&scoped=true"
import script from "./TypeWriter.vue?vue&type=script&lang=js"
export * from "./TypeWriter.vue?vue&type=script&lang=js"

import "./TypeWriter.vue?vue&type=style&index=0&id=80dc6f64&scoped=true&lang=css"

import exportComponent from "E:\\work\\code\\ai-view\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dc6f64"]])

export default __exports__